import { render } from "./COLOC.vue?vue&type=template&id=c0153936"
import script from "./COLOC.vue?vue&type=script&lang=js"
export * from "./COLOC.vue?vue&type=script&lang=js"

import "./COLOC.vue?vue&type=style&index=0&id=c0153936&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__